module.exports = __webpack_public_path__ + "img/arrow-left.d75ce55f.svg";